import React from "react";
import { CertificateElement } from "./certificateTypes";

type CertificateElementViewProps = {
  element: CertificateElement;
  selected: boolean;
  interactive: boolean;
  content: string;
  inheritedFontFamily: string;
  onSelect: (id: string) => void;
  onMoveStart: (event: React.PointerEvent, id: string) => void;
  onResizeStart: (event: React.PointerEvent, id: string) => void;
  logoSrc?: string;
};

function CertificateElementView({
  element,
  selected,
  interactive,
  content,
  inheritedFontFamily,
  onSelect,
  onMoveStart,
  onResizeStart,
  logoSrc,
}: CertificateElementViewProps) {
  if (!element.visible) return null;

  return (
    <div
      className={`certificate-element${selected ? " is-selected" : ""}${
        element.type === "logo" ? " is-logo" : ""
      }${element.textTransform === "uppercase" ? " is-uppercase" : ""}${
        element.textTransform === "capitalize" ? " is-capitalize" : ""
      }`}
      style={{
        left: `${element.x}mm`,
        top: `${element.y}mm`,
        width: `${element.width}mm`,
        height: `${element.height}mm`,
        fontSize: `${element.fontSize}pt`,
        fontWeight: element.fontWeight,
        fontFamily: element.fontFamily || inheritedFontFamily,
        textAlign: element.align,
        lineHeight: element.lineHeight,
        letterSpacing: element.letterSpacing ? `${element.letterSpacing}px` : undefined,
        color: element.color,
        cursor: interactive ? "move" : "default",
      }}
      onPointerDown={(event) => {
        if (!interactive) return;
        event.stopPropagation();
        onSelect(element.id);
        onMoveStart(event, element.id);
      }}
    >
      {element.type === "logo" ? (
        <img src={logoSrc} alt="" />
      ) : (
        content
      )}
      {interactive && selected ? (
        <span
          className="certificate-resize-handle"
          onPointerDown={(event) => {
            event.stopPropagation();
            onResizeStart(event, element.id);
          }}
        />
      ) : null}
    </div>
  );
}

export default CertificateElementView;
